<template>
  <div>
    <v-btn 
      :loading="loading"
      :disabled="loading"
      color="primary"
      @click="fetchRecruitmentInfo"
      class="recruitment-button">
      获取近四天爱私益校招信息
    </v-btn>
  </div>
</template>

<script>
import { adminToolApi } from "@/api/tool";
import { commonUtils } from "@/utils/commonUtils.js";

export default {
  name: "RecruitmentInfoButton",
  data() {
    return {
      loading: false, // 控制按钮是否处于加载状态
    }
  },
  methods: {
    async fetchRecruitmentInfo() {
      this.loading = true;
      try {
        const response = await adminToolApi.scratch_recruitment();

        // 生成带日期的文件名
        const dateString = new Date().toISOString().slice(0, 10);
        const filename = `爱私益校招信息_${dateString}.xlsx`;
      
        commonUtils.popupDownloadFile(response, filename);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false; // 请求结束（无论成功或失败）后设置为 false
      }
    },
  },
};
</script>

<style scoped>
.recruitment-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.recruitment-button:hover {
  background-color: #45a049;
}
</style>